// @flow
/* eslint-disable import/max-dependencies */
import {
  combineReducers,
  applyMiddleware,
  createStore,
  compose,
} from "redux";
import type { Dispatch, Store, CombinedReducer } from "redux";
import createSagaMiddleware from "redux-saga";
import type { SagaMiddleware } from "redux-saga";
import Immutable from "immutable";
import form, {
  initFormState,
  type State as FormState,
} from "@fas/ui-framework/lib/redux/reducers/form";
import loading, {
  initLoadingState,
  type State as LoadingState,
} from "@fas/ui-framework/lib/redux/reducers/loading";
import notifications, {
  type State as NotificationsState,
  initNotificationsState,
} from "@fas/ui-framework/lib/redux/reducers/notifications";
import type { Actions as LoadingActions } from "@fas/ui-framework/lib/redux/actions/loading";
import type { Actions as FormActions } from "@fas/ui-framework/lib/redux/actions/form";
import type { Action as NotificationsActions } from "@fas/ui-framework/lib/redux/actions/notifications";
import mainSaga from "./saga";
import {
  FORM_KEY_MESSAGE_GROUP,
  GET_FORM_DATA_LOADING,
  SAVE_FORM_DATA_LOADING,
} from "../../helpers/constants";
import type { MessageGroupFormData } from "../../containers/CreateMessageGroup";

export const defaultFormData: MessageGroupFormData = {
  id: "",
  name: "",
  isActive: true,
  browserLanguages: [],
  placements: [],
  sendStrategies: 0,
  messages: [],
  tag: "",
  usedInCampaigns: [],
};

export type State = $ReadOnly<{|
  loading: LoadingState<string>,
  notifications: NotificationsState,
  form: FormState,
|}>

export function mapMessageGroupToState(): State {
  return {
    form: initFormState({
      [FORM_KEY_MESSAGE_GROUP]: defaultFormData,
    }),
    loading: initLoadingState({
      [GET_FORM_DATA_LOADING]: false,
      [SAVE_FORM_DATA_LOADING]: false,
    }),
    notifications: initNotificationsState(),
  };
}

export type Actions = LoadingActions<string>
  | NotificationsActions
  | FormActions<MessageGroupFormData>

const reducers: CombinedReducer<State, Actions> = combineReducers({
  loading,
  notifications,
  form,
});

const sagaMiddleware: SagaMiddleware<{}> = createSagaMiddleware();

export default (): Store<State, Actions> => {
  // eslint-disable-next-line no-underscore-dangle, flowtype/require-variable-type
  const composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    serialize: {
      immutable: Immutable,
    },
  }) : compose;

  const store: Store<State, Actions> = createStore<State, Actions, Dispatch<Actions>>(
    reducers,
    mapMessageGroupToState(),
    composeEnhancers(applyMiddleware(
      sagaMiddleware
    ))
  );

  sagaMiddleware.run(mainSaga);

  return store;
};
